import { ColumnDetails } from '../../../../grid/types/common';
import { html } from 'lit';
import { Column, ColumnKeys, DOMAIN_CONTROLLER_STATUS, DomainControllerRoleEnum } from '../types';
import { BaseWebComponentTranslator } from '../../../../framework/BaseWebComponentTranslator';

export function statusRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];
  let status, bubble;

  switch (cellValue) {
    case DOMAIN_CONTROLLER_STATUS.NotInstalled:
      status = this.dependencies.translateFn('Not configured (EDR not installed)');
      bubble = 'bullet-neutral';
      break;
    case DOMAIN_CONTROLLER_STATUS.BadAuditPoliciesConfig:
    case DOMAIN_CONTROLLER_STATUS.BadCertificateAuditPoliciesConfig:
      status = this.dependencies.translateFn('Not configured (group policy required)');
      bubble = 'bullet-neutral';
      break;
    case DOMAIN_CONTROLLER_STATUS.Offline:
      status = this.dependencies.translateFn('Offline');
      bubble = 'bullet-danger';
      break;
    case DOMAIN_CONTROLLER_STATUS.READY:
      status = this.dependencies.translateFn('Ready to use');
      bubble = 'bullet-success';
      break;
    case DOMAIN_CONTROLLER_STATUS.LicenseExpired:
      status = this.dependencies.translateFn('License expired');
      bubble = 'bullet-danger';
      break;
    default:
      break;
  }

  return html`<span class="cell-label has-bullet ${bubble}">${status}</span>`;
}


export function roleRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>): string {
  return getRolesTranslated(rowData.item[columnDetails.key]);
}

export function getRolesTranslated(roles: DomainControllerRoleEnum[] = []): string {
  const translator = BaseWebComponentTranslator.getInstance();
  return roles.length > 0 ? roles.map((role) => {
    return translator.translateDomainControllerRoles(role);
  }).join(', ') : translator.translateDomainControllerRoles(DomainControllerRoleEnum.DOMAIN_CONTROLLER);
}
